import getCount from "./get-count.js";
import clearSingle from "./clear-single.js";
import clearAll from "./clear-all.js";
import processImage from "./process-image.js";
import getSingleCount from "./get-single-count.js";
import optimiseImage from "./optimise-image.js";
import checks from "./checks/index.js";

export default {
	checks,
	getCount,
	clearSingle,
	clearAll,
	processImage,
	getSingleCount,
	optimiseImage,
};
